import { useState } from "react";
import PropTypes from "prop-types";
import { Alert, Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import Lang from "components/Lang";

const PasswordRegistrar = ({ submit, error }) => {
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const checkSubmittable = () => Boolean((password1 && password2) && (password1 === password2));
  const submitHandler = (event) => {
    event.preventDefault();
    if (!checkSubmittable()) {
      return;
    }
    submit(password1);
  };
  return (
    <Container fluid={true}>
      <Row className="mt-5">
        <Col xs={"12"} sm={{ span: "8", offset: "2" }} md={{ span: "6", offset: "3" }} lg={{ span: "4", offset: "4" }} >
          <h3><Lang>本パスワード設定</Lang></h3>
          <Card>
            <Card.Body>
              {error && (
                <Alert variant="warning">
                  <p className="mb-0"><Lang>設定できませんでした。</Lang></p>
                  <ul className="mb-0">
                    <li><Lang>パスワード確認が一致していますか。</Lang></li>
                    <li><Lang>ルールに合致していますか。</Lang></li>
                  </ul>
                </Alert>
              )}
              <Form onSubmit={submitHandler}>
                <Form.Group className="mb-3">
                  <Lang> {/* TODO placeholder 新しいパスワード */}
                    <Form.Control
                      type="password"
                      value={password1}
                      placeholder="新しいパスワード"
                      onChange={(event) => setPassword1(event.target.value)}
                    />
                  </Lang>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Lang> {/* TODO placeholder 新しいパスワード（確認） */}
                    <Form.Control
                      type="password"
                      value={password2}
                      placeholder="新しいパスワード（確認）"
                      onChange={(event) => setPassword2(event.target.value)}
                    />
                  </Lang>
                  <Form.Text muted><Lang>半角英数記号 8文字以上 大文字/小文字/数字必須</Lang></Form.Text>
                </Form.Group>
                <Form.Group className="clearfix">
                  <Button variant="primary" className="float-end" type="submit" disabled={!checkSubmittable()}>
                    <Lang>設定</Lang>
                  </Button>
                </Form.Group>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
PasswordRegistrar.propTypes = {
  submit: PropTypes.func.isRequired
};

export default PasswordRegistrar;